import { render } from "./AdminWalkInModal.vue?vue&type=template&id=0b1c33ad&scoped=true"
import script from "./AdminWalkInModal.vue?vue&type=script&lang=js"
export * from "./AdminWalkInModal.vue?vue&type=script&lang=js"

import "./AdminWalkInModal.vue?vue&type=style&index=0&id=0b1c33ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1c33ad"]])

export default __exports__